import React from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import { slide as Menu  } from 'react-burger-menu';

class BurgerMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menuOpen: false
        }
    }

    handleStateChange() {
        this.setState({menuOpen: this.state.isOpen})
    }
    
    closeMenu() {
        this.setState({
            menuOpen: false
        });
    }

    render () {
        let startLink;
        let referenceLink;
        let leistungenLink;
        let weLink;
        let impressumLink;

        if (this.props.site === 1) {
            startLink = <AnchorLink href='#start' onClick={() => this.closeMenu()}>Start</AnchorLink>;
            referenceLink = <AnchorLink href='#subheader' onClick={() => this.closeMenu()}>Über Uns</AnchorLink>;
            leistungenLink = <AnchorLink href='#gallery_parent' onClick={() => this.closeMenu()}>Referenzen</AnchorLink>;
            weLink = <AnchorLink href='#kontakt' onClick={() => this.closeMenu()}>Kontakt</AnchorLink>;
            impressumLink = <a href='/impressum' onClick={() => this.closeMenu()}>Impressum</a>;

        } else if (this.props.site === 2 || this.props.site === 3) {
            startLink = <a href='/' onClick={() => this.handleOnClose}>Start</a>;
            referenceLink = <a href='/#subheader' onClick={() => this.handleOnClose}>Über Uns</a>;
            leistungenLink = <a href='/#gallery_parent' onClick={() => this.handleOnClose}>Referenzen</a>;
            weLink = <a href='/#kontakt' onClick={() => this.handleOnClose}>Kontakt</a>;
            impressumLink = <AnchorLink href='#impressum' onClick={() => this.handleOnClose}>Impressum</AnchorLink>;
        }

        return (
            <Menu 
                right
                disableAutoFocus
                isOpen={ this.state.menuOpen }
                onStateChange={(state) => this.handleStateChange(state)}>
                    {startLink}
                    {referenceLink}
                    {leistungenLink}
                    {weLink}
                    {impressumLink}
            </Menu>
        );
    }
}

export default BurgerMenu;  